/*
 * @Author: dengyong dengyong@caohua.com
 * @Date: 2022-08-16 15:08:20
 * @LastEditors: yangyi yangyi@caohua.com
 * @LastEditTime: 2026-05-29 17:28:39
 * @FilePath: /tiangong-vue2.7/src/views/report/comprehension-report/js/dimensionsData.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const checkedData = [
  {
    label: '计划',
    key: 'dimPlan',
    disabled: false
  },
  {
    label: '素材',
    key: 'dimImage',
    disabled: false
  },
  {
    label: '平台',
    key: 'dimPlatform',
    disabled: false
  },
  {
    label: '应用组',
    key: 'dimGameGroup',
    disabled: false
  },
  {
    label: '应用',
    key: 'dimGame',
    disabled: false
  },
  {
    label: '项目组',
    key: 'dimProjectGroup',
    disabled: false
  },
  {
    label: '人员',
    key: 'dimOp',
    disabled: false
  },
  {
    label: '媒体',
    key: 'dimMedia',
    disabled: false
  },
  {
    label: '投放版位',
    key: 'dimAdvPosition',
    disabled: false
  },
  {
    label: '账号',
    key: 'dimAdAccount',
    disabled: false
  },
  {
    label: '优化目标',
    key: 'dimOptimizationType',
    disabled: true
  },
  {
    label: '深度优化目标',
    key: 'dimDeepOptimizationType',
    disabled: true
  },
  {
    label: '流量来源',
    key: 'dimLaunchSource',
    disabled: false
  }
]

const mediaDimensionIndex = checkedData.findIndex((item) => item.key === 'dimMedia')

export const checkedDataForComplex = [
  ...checkedData.slice(0, mediaDimensionIndex + 1),
  {
    label: '媒体版本',
    key: 'dimSubMedia',
    disabled: false
  },
  ...checkedData.slice(mediaDimensionIndex + 1),
  {
    label: '代投账号',
    key: 'dimProxyAccount',
    disabled: false
  },
  {
    label: '投放模式',
    key: 'dimLaunchMode',
    disabled: false
  },
  {
    label: '竞价策略',
    key: 'dimBiddingStrategy',
    disabled: false
  },
  {
    label: '原生/达人/常规计划',
    key: 'dimNativeAdvert',
    disabled: false
  },
  {
    label: '抖音号',
    key: 'dimDouyinNo',
    disabled: false
  },
  {
    label: '视频号',
    key: 'dimShipinNo',
    disabled: false
  },
  {
    label: '快手号',
    key: 'dimKuanshouNo',
    disabled: false
  },
  {
    label: '性别',
    key: 'dimGender',
    disabled: false
  },
  {
    label: '年龄',
    key: 'dimAge',
    disabled: false
  },
  {
    label: '定向人群包',
    key: 'dimRetargetingTagsIncludes',
    disabled: false
  },
  {
    label: '排除人群包',
    key: 'dimRetargetingTagsExcludes',
    disabled: false
  },
  {
    label: '媒体平台',
    key: 'dimMediaPlatform',
    disabled: false
  },
  {
    label: '投放类型',
    key: 'dimDeliveryType',
    disabled: false
  }
]

export const dimensionsData = [
  {
    title: '计划',
    key: 'planName',
    width: 100,
    overflow: true,
    align: 'left',
    showKey: 'dimPlan'
  },
  {
    title: '素材',
    key: 'imageName',
    overflow: true,
    width: 74,
    align: 'left',
    showKey: 'dimImage'
  },
  {
    title: '平台',
    key: 'platform',
    overflow: true,
    width: 84,
    align: 'left',
    showKey: 'dimPlatform'
  },
  {
    title: '应用组',
    key: 'gameGroupName',
    width: 80,
    overflow: true,
    align: 'left',
    showKey: 'dimGameGroup'
  },
  {
    title: '应用',
    key: 'gameName',
    width: 74,
    overflow: true,
    align: 'left',
    showKey: 'dimGame'
  },
  {
    title: '项目组',
    key: 'projectGroupName',
    width: 74,
    overflow: true,
    align: 'left',
    showKey: 'dimProjectGroup'
  },
  {
    title: '人员',
    key: 'opName',
    width: 74,
    overflow: true,
    align: 'left',
    showKey: 'dimOp'
  },
  {
    title: '媒体',
    key: 'mediaName',
    width: 74,
    overflow: true,
    align: 'left',
    showKey: 'dimMedia'
  },
  {
    title: '媒体版本',
    key: 'subMediaName',
    width: 90,
    overflow: true,
    align: 'left',
    showKey: 'dimSubMedia'
  },
  {
    title: '投放版位',
    key: 'advPositionName',
    width: 74,
    overflow: true,
    align: 'left',
    showKey: 'dimAdvPosition'
  },
  {
    title: '账号',
    key: 'adAccountName',
    width: 140,
    overflow: true,
    align: 'left',
    showKey: 'dimAdAccount'
  },
  {
    title: '优化目标',
    key: 'optimizationTypeName',
    width: 90,
    overflow: true,
    align: 'left',
    showKey: 'dimOptimizationType'
  },
  {
    title: '深度优化目标',
    key: 'deepOptimizationTypeName',
    width: 70,
    overflow: true,
    align: 'left',
    showKey: 'dimDeepOptimizationType'
  },
  {
    title: '流量来源',
    key: 'launchSourceName',
    width: 90,
    overflow: true,
    align: 'left',
    showKey: 'dimLaunchSource'
  },
  {
    title: '代投账号',
    key: 'proxyAccountName',
    disabled: false,
    width: 90,
    overflow: true,
    align: 'left',
    showKey: 'dimProxyAccount'
  },
  {
    title: '投放模式',
    key: 'launchModeName',
    disabled: false,
    width: 90,
    overflow: true,
    align: 'left',
    showKey: 'dimLaunchMode'
  },
  {
    title: '竞价策略',
    key: 'biddingStrategyName',
    disabled: false,
    width: 90,
    overflow: true,
    align: 'left',
    showKey: 'dimBiddingStrategy'
  },
  {
    title: '原生/达人/常规计划',
    key: 'nativeAdvertName',
    disabled: false,
    width: 90,
    overflow: true,
    align: 'left',
    showKey: 'dimNativeAdvert'
  },
  {
    title: '抖音号',
    key: 'douyinName',
    disabled: false,
    width: 90,
    overflow: true,
    align: 'left',
    showKey: 'dimDouyinNo'
  },
  {
    title: '视频号',
    key: 'shipinName',
    disabled: false,
    width: 90,
    overflow: true,
    align: 'left',
    showKey: 'dimShipinNo'
  },
  {
    title: '快手号',
    key: 'kuanshouName',
    disabled: false,
    width: 90,
    overflow: true,
    align: 'left',
    showKey: 'dimKuanshouNo'
  },
  {
    title: '性别',
    key: 'genderName',
    disabled: false,
    width: 90,
    overflow: true,
    align: 'left',
    showKey: 'dimGender'
  },
  {
    title: '年龄',
    key: 'age',
    disabled: false,
    width: 90,
    overflow: true,
    align: 'left',
    showKey: 'dimAge'
  },
  {
    title: '定向人群包',
    key: 'retargetingTagsIncludesName',
    disabled: false,
    width: 90,
    overflow: true,
    align: 'left',
    showKey: 'dimRetargetingTagsIncludes'
  },
  {
    title: '排除人群包',
    key: 'retargetingTagsExcludesName',
    disabled: false,
    width: 90,
    overflow: true,
    align: 'left',
    showKey: 'dimRetargetingTagsExcludes'
  },
  {
    title: '媒体平台',
    key: 'mediaPlatformName',
    disabled: false,
    width: 90,
    overflow: true,
    align: 'left',
    showKey: 'dimMediaPlatform'
  },
  {
    title: '投放类型',
    key: 'deliveryTypeName',
    disabled: false,
    width: 140,
    overflow: true,
    align: 'left',
    showKey: 'dimDeliveryType'
  }
]
export const checkedObj = {
  计划: 'dimPlan',
  素材: 'dimImage',
  平台: 'dimPlatform',
  应用组: 'dimGameGroup',
  应用: 'dimGame',
  项目组: 'dimProjectGroup',
  人员: 'dimOp',
  媒体: 'dimMedia',
  投放版位: 'dimAdvPosition',
  账号: 'dimAdAccount',
  优化目标: 'dimOptimizationType',
  深度优化目标: 'dimDeepOptimizationType',
  流量来源: 'dimLaunchSource'
}

export const checkedObjForComplex = {
  ...checkedObj,
  媒体版本: 'dimSubMedia',
  代投账号: 'dimProxyAccount',
  投放模式: 'dimLaunchMode',
  竞价策略: 'dimBiddingStrategy',
  '原生/达人/常规计划': 'dimNativeAdvert',
  抖音号: 'dimDouyinNo',
  视频号: 'dimShipinNo',
  快手号: 'dimKuanshouNo',
  性别: 'dimGender',
  年龄: 'dimAge',
  定向人群包: 'dimRetargetingTagsIncludes',
  排除人群包: 'dimRetargetingTagsExcludes',
  媒体平台: 'dimMediaPlatform',
  投放类型: 'dimDeliveryType'
}
